import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsRecoveryFreespins extends Decision {
    public evaluate() {
        const gameplay = GameState.getCurrentGame();

        const isRecovery = gameplay.isRecovered;
        const isFreespins = GameState.getCurrentGame().areFreespinsPending() && GameState.getCurrentGame().getFreespinsPlayed() > 0;

        return isRecovery && isFreespins  ? Exit.True : Exit.False;
    }
}
